import { Box, Stack, Typography } from "@mui/material";
import { MaterialRead, MixedMaterialPair } from "src/store/api/generatedApi";
import { useTenantTranslation } from "hooks/formatters";

export const MixedLiftsSummary = ({
  pairs,
  materials,
}: {
  pairs: MixedMaterialPair[];
  materials: MaterialRead[];
}) => {
  const { t } = useTenantTranslation();
  if (pairs.length === 0) return null;

  const colourByName = new Map(
    materials.map((material) => [material.name, material.colour])
  );
  const totalMixedLifts = pairs.reduce((sum, pair) => sum + pair.num_lifts, 0);

  const materialDot = (name: string) => (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        flexShrink: 0,
        bgcolor: colourByName.get(name) ?? "grey.400",
      }}
    />
  );

  return (
    <Stack spacing={1} sx={{ mt: 3, px: 1 }}>
      <Typography variant="body1" sx={{ fontWeight: "fontWeightMedium" }}>
        {t("mixedLiftsCount", { count: totalMixedLifts })}
      </Typography>
      <Stack spacing={0.5}>
        {pairs.map((pair) => (
          <Stack
            key={`${pair.material_a}\0${pair.material_b}`}
            direction="row"
            alignItems="center"
            spacing={1}
          >
            {materialDot(pair.material_a)}
            {materialDot(pair.material_b)}
            <Typography variant="body2">
              {t("materialPair", {
                materialA: pair.material_a,
                materialB: pair.material_b,
              })}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {t("nLifts", { count: pair.num_lifts })}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
